import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

import img from "../../assets/img.png";
import img1 from "../../assets/Helthcare.jpg";
import img2 from "../../assets/banner.jpg";
import img3 from "../../assets/banner1.png";

const banners = [
  {
    image: img,
    tag: "EDUCATION INITIATIVE",
    mainTitle: "India's Future Starts in a Classroom.",
    description:
      "Join our Mission to provide quality education and key learning resources to children in underserved communities.",
    btnText: "Fund a Student <span>🇮🇳</span>",
    altText: "Child education NGO initiative by Sevaa Foundation in India"
  },
  {
    image: img1,
    tag: "HEALTHCARE MISSION",
    mainTitle: "Dignified Healthcare is a Fundamental Right.",
    description:
      "Support our mobile medical clinics and healthcare camps reaching remote villages and urban slums.",
    btnText: "Support Healthcare <span>❤️</span>",
    altText: "Healthcare camps and medical support NGO Sevaa Foundation"
  },
  {
    image: img2,
    tag: "WOMEN EMPOWERMENT",
    mainTitle: "Self-Reliance for Women Builds Nations.",
    description:
      "Give livelihood skills training and essential resources to empower women and ensure their economic independence.",
    btnText: "Empower a Woman <span>👩🏽</span>",
    altText: "Women empowerment and livelihood training by Swadesh Sevaa Charitable Foundation"
  },
  {
    image: img3,
    tag: "NUTRITION & RELIEF",
    mainTitle: "No Child Should Go to Sleep Hungry.",
    description:
      "Contribute to our daily meal drives and emergency food relief operations across the country.",
    btnText: "Donate a Meal <span>🍛</span>",
    altText: "Hunger support and food donation relief by Sevaa Foundation"
  },
];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const openDonate = () => {
    window.dispatchEvent(new Event("openDonationModal"));
  };

  return (
    <div className="relative min-h-[75vh] bg-slate-900 overflow-hidden flex items-center">
      {/* 1. Cinematic Background Image Animation */}
      <AnimatePresence mode="popLayout">
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0, scale: 1.08 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
          className="absolute inset-0 z-0"
        >
          <img
            src={banners[currentSlide].image}
            alt={banners[currentSlide].altText}
            className="w-full h-full object-cover"
            loading={currentSlide === 0 ? "eager" : "lazy"}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/50 to-transparent z-0"></div>
        </motion.div>
      </AnimatePresence>

      {/* 2. Animated Content Container */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full mt-8 md:mt-0">
        <AnimatePresence mode="wait">
          <motion.div
            key={`text-${currentSlide}`}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="max-w-2xl"
          >
            {/* Tag */}
            <div className="flex items-center gap-2 mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-500 shadow-[0_0_8px_#f97316]"></span>
              <span className="text-orange-400 font-bold text-sm tracking-widest uppercase">
                {banners[currentSlide].tag}
              </span>
            </div>

            {/* Main Title (Acting as H1 visually, but SEO H1 should ideally be in main page, this is fine for Hero context) */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight text-white drop-shadow-lg">
              {banners[currentSlide].mainTitle}
            </h1>

            {/* Description */}
            <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-xl leading-relaxed drop-shadow-md border-l-4 border-orange-500 pl-4">
              {banners[currentSlide].description}
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={openDonate}
                className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3.5 rounded-md font-bold text-lg transition-colors shadow-lg shadow-orange-600/30 flex items-center justify-center gap-2 transform hover:scale-105"
                dangerouslySetInnerHTML={{
                  __html: banners[currentSlide].btnText,
                }}
                aria-label={`Donate to ${banners[currentSlide].tag}`}
              />

              <Link to="/volunteer">
                <button 
                  className="bg-transparent hover:bg-white/10 border border-white/50 hover:border-white text-white px-8 py-3.5 rounded-md font-bold text-lg transition-all flex items-center justify-center backdrop-blur-sm transform hover:scale-105"
                  aria-label="Become an NGO volunteer"
                >
                  Become a Volunteer
                </button>
              </Link>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* 3. Custom Pagination Dots */}
      <div className="absolute bottom-10 left-0 right-0 z-20 flex justify-center gap-3">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`transition-all duration-500 ease-in-out rounded-full shadow-md ${
              currentSlide === index
                ? "w-10 h-2.5 bg-orange-500"
                : "w-2.5 h-2.5 bg-white/50 hover:bg-white"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Hero;